<template>
	<div class="Print" :class="{ 'is-mobile': isMobile }">
		<common-body :aside="aside[status]">
			<div slot="commonMain" class="quotation_box" v-loading.lock="loadingStatus">
				<div v-if="detail">
					<div class="quotation_header">
						<el-row type="flex" align="middle" justify="space-between" class="header_content">
							<el-row type="flex" align="middle" class="location_box">
								<div class="location_icon">
									<i class="el-icon-s-promotion"></i>
								</div>
								<el-row type="flex" align="middle" class="location_text">
									<div v-if="!isMobile">当前位置：</div>
									<el-button @click="goBack" type="text">{{statusText[status]}}</el-button>
									<div class="location_xie">/</div>
									<div>{{title[status]}}打印预览</div>
								</el-row>
							</el-row>
							<el-row type="flex" align="middle" class="header_r">
								<div v-if="Number(status)==1" @click="exportExcel" class="header_btn header_btn3">导出Excel</div>
								<div v-if="Number(status)==1 || Number(status)==2" @click="toShot" class="header_btn header_btn2">截图</div>
								<div v-if="!isMobile" @click="toImg" class="header_btn header_btn1">立即打印</div>
							</el-row>
						</el-row>
					</div>
					<div class="print-sheet-viewport" :style="sheetViewportStyle">
					<div ref="offerPrint" class="quotation_form" :style="sheetScaleStyle">
						<div class="offer_header">
							<div class="offer_title">{{detail.printTitle}}</div>
							<div class="offer_logo">
								<img src="@/assets/maitu-logo.svg" />
							</div>
						</div>
						<el-row type="flex" justify="space-between" class="customer_info">
							<div class="customer_l">
								<div class="customer_text"><span>客户名称：</span>{{detail.customer_id}}</div>
								<div class="customer_text"><span>收货地址：</span>{{detail.receiving_address}}</div>
								<el-row type="flex" class="customer_b">
									<div class="customer_text"><span>联系人：</span>{{detail.contacts}}</div>
									<div class="customer_text"><span>联系电话：</span>{{detail.contacts_phone}}</div>
								</el-row>
							</div>
							<div class="customer_r">
								<div class="customer_text"><span>报价编号：</span>{{detail.order_number}}</div>
								<div class="customer_text"><span>报价日期：</span>{{detail.createTime}}</div>
								<div v-if="status==1" class="customer_text"><span>发票类型：</span>{{detail.invoice_text}}</div>
							</div>
						</el-row>
						<el-row type="flex" align="middle" justify="space-between" class="quotation_title">
							<div class="title_text">{{ listTitleText }}</div>
						</el-row>
						<!-- 报价单 -->
						<div class="print-table-scroll">
						<el-table ref="printTable" border stripe class="printTable" :row-class-name="printTableRowClassName" :data="printTableRows" style="width: 100%" cell-class-name="good_text"
						 header-cell-class-name="good_header">
							<el-table-column key="print-col-index" :resizable="resizeable" align="center" width="52" label="序号" class-name="print-col-index" header-class-name="print-col-index">
								<template slot-scope="scope">
									<div>{{scope.$index+1}}</div>
								</template>
							</el-table-column>
							<el-table-column key="print-col-name" :resizable="resizeable" align="center" min-width="15.4%" label="名称" class-name="print-col-name" header-class-name="print-col-name">
								<template slot-scope="scope">
									<div v-if="isExtraTableRow(scope.row)" class="good_name extra-cell-name" :title="scope.row.name">{{ scope.row.name }}</div>
									<div v-else class="good_name" :title="cartDisplayName(scope.row)">{{ cartDisplayName(scope.row) }}</div>
								</template>
							</el-table-column>
							<el-table-column v-if="detail.category!=13&&detail.category!=19&&detail.category!=29&&detail.category!=30&&detail.category!=31&&detail.category!=40&&detail.category!=43&&detail.category!=45" key="print-col-size" :resizable="resizeable" align="center" :min-width="Number(status)==4 ? '6.4%' : '8%'" label="尺寸(mm)" class-name="print-col-size" header-class-name="print-col-size">
								<template slot-scope="scope">
									<div class="good_size">
										<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
										<div v-else-if="scope.row.goods_valuation==1">-</div>
										<div v-else>{{ formatSizeText(scope.row.size_text) }}</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column key="print-col-spec" :resizable="resizeable" align="center" :min-width="Number(status)==4 ? '16.8%' : '21%'" label="规格参数" class-name="print-col-spec" header-class-name="print-col-spec">
								<template slot-scope="scope">
									<el-row type="flex" align="middle" justify="center" class="good_size">
										<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
										<span v-else>{{ scope.row.parameter_text }}</span>
									</el-row>
								</template>
							</el-table-column>
							<el-table-column v-if="detail.category==20||detail.category==25||detail.category==26||detail.category==27||detail.category==28||detail.category==32||detail.category==33||detail.category==44" key="print-col-areas" :resizable="resizeable" align="center" min-width="4%" label="面积(㎡)" class-name="is-num">
								<template slot-scope="scope">
									<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
									<span v-else>{{ scope.row.goods_areas }}</span>
								</template>
							</el-table-column>
							<el-table-column key="print-col-num" :resizable="resizeable" align="center" min-width="3.2%" label="数量" class-name="print-col-num" header-class-name="print-col-num">
								<template slot-scope="scope">
									<span>{{ scope.row.goods_num }}</span>
								</template>
							</el-table-column>
							<el-table-column key="print-col-unit" :resizable="resizeable" align="center" min-width="3.2%" label="单位" class-name="print-col-unit" header-class-name="print-col-unit">
								<template slot-scope="scope">
									<span v-if="isExtraTableRow(scope.row)" class="extra-cell-unit">{{ scope.row.goods_unit }}</span>
									<span v-else>{{ scope.row.goods_unit }}</span>
								</template>
							</el-table-column>
							<el-table-column v-if="status==1" key="print-col-price" :resizable="resizeable" align="center" min-width="5%" label="单价" class-name="is-amount">
								<template slot-scope="scope">
									<span v-if="isExtraTableRow(scope.row)" class="amount extra-cell-amount">{{ formatMoney(scope.row.singleton) }}</span>
									<el-input
										v-else-if="isEditingCell('singleton', scope.row._cartIndex)"
										v-model="inlineEditValue"
										class="table_input print-inline-input"
										size="small"
										@blur="commitSingletonEdit(scope.row._cartIndex)"
										@keyup.enter.native="commitSingletonEdit(scope.row._cartIndex)" />
									<div
										v-else
										class="amount print-editable-cell"
										title="双击修改"
										@dblclick="startInlineEdit('singleton', scope.row._cartIndex, scope.row.singleton)">{{ formatMoney(scope.row.singleton) }}</div>
								</template>
							</el-table-column>
							<el-table-column v-if="status==1" key="print-col-amount" :resizable="resizeable" align="center" min-width="5%" label="金额" class-name="is-amount">
								<template slot-scope="scope">
									<div v-if="isExtraTableRow(scope.row)" class="amount extra-cell-amount">{{ formatMoney(scope.row.amount) }}</div>
									<div v-else class="amount">{{ formatAmountBySingleton(scope.row) }}</div>
								</template>
							</el-table-column>
							<el-table-column v-if="status==4" key="print-col-process-size" :resizable="resizeable" align="center" min-width="6%" prop="godds_addSize"
							 label="加工尺寸(mm)">
							</el-table-column>
							<el-table-column key="print-col-remark" :resizable="resizeable" align="center" :min-width="Number(status)==4 ? '12%' : '10%'" label="备注" class-name="print-col-remark" header-class-name="print-col-remark">
								<template slot-scope="scope">
									<div class="good_remark_text" :class="{ 'extra-cell-remark': isExtraTableRow(scope.row) }">{{ scope.row.remarks || ' ' }}</div>
								</template>
							</el-table-column>
						</el-table>
						</div>
						<div class="goods_footer">
							<el-row v-if="status==1" type="flex" align="middle" class="goods_footer_item goods_footer_item--amount-pair">
								<el-row type="flex" align="middle" class="goods_footer_subtotal_wrap">
									<div class="goods_footer_text">小计：<span>¥</span></div>
									<div class="goods_footer_value goods_footer_value--price">{{ formatFooterMoney(detail.totalAll) }}</div>
								</el-row>
								<el-row type="flex" align="middle" class="goods_footer_concession">
									<div class="goods_footer_text">折扣让利：<span>-¥</span></div>
									<div class="print-concession-field">
										<input
											v-if="editingConcession"
											ref="concessionInput"
											v-model="concessionEditValue"
											class="print-concession-input"
											type="text"
											inputmode="decimal"
											placeholder="0.00"
											@blur="finishConcessionEdit"
											@keydown.enter.prevent="finishConcessionEdit"
											@keydown.esc.prevent="cancelConcessionEdit" />
										<div
											v-else
											class="print-concession-display"
											title="双击修改（仅本页预览，刷新后恢复）"
											@dblclick="startConcessionEdit">{{ formatFooterMoney(detail.concessionAbs) }}</div>
									</div>
								</el-row>
							</el-row>
							<el-row v-if="status==1" type="flex" align="middle" class="goods_footer_item">
								<div class="goods_footer_text">合计：<span>¥</span></div>
								<div class="goods_footer_value goods_footer_value--price">{{ formatFooterMoney(detail.total) }}</div>
							</el-row>
							<el-row v-if="status==1" type="flex" align="middle" class="goods_footer_item">
								<div class="goods_footer_text">金额大写：</div>
								<div class="goods_footer_value goods_footer_value--cny">{{ detail.totalText || ' ' }}</div>
							</el-row>
							<div class="goods_footer_item goods_footer_item--remark">
								<div class="goods_footer_remark_block">
									<div class="goods_footer_remark_row">
										<div class="goods_footer_remark_label">订单备注：</div>
										<div class="goods_footer_remark_content">{{ detail.remarks || ' ' }}</div>
									</div>
									<div class="goods_footer_text goods_footer_maker">制单人：{{ detail.user_name }}</div>
								</div>
							</div>
						</div>
						<el-row v-if="status==1" type="flex" justify="space-between" class="customer_info">
							<div class="customer_l">
								<div class="customer_text"><span>运输方式：</span>{{detail.delivery_text}}</div>
								<div class="customer_text"><span>联系地址：</span>{{userInfo.address}}</div>
							</div>
							<div class="customer_r">
								<div class="customer_text"><span>公司名称：</span>{{userInfo.company_name&&userInfo.company_name!=""?userInfo.company_name:""}}</div>
								<div class="customer_text"><span>联系电话：</span>{{userInfo.mobile}}</div>
							</div>
						</el-row>
						<div v-if="status==1 && payQrcode" class="pay_box">
							<img :src="payQrcode" alt="账户信息" />
						</div>
						<div v-if="printGoodsStats.detailRows.length" class="print-goods-stats">
							<div class="print-goods-stats__head">
								<div class="print-goods-stats__meta">
									<span class="print-goods-stats__title">统计</span>
									<span class="print-goods-stats__sub">产品 <span class="num">{{ printGoodsStats.productTypeText }}</span> 类</span>
								</div>
								<span class="print-goods-stats__note">
									<svg class="print-goods-stats__warn" viewBox="0 0 24 24" aria-hidden="true">
										<path d="M12 2L1 21h22L12 2z" fill="#d97706"/>
										<path d="M12 9v6M12 17.5v.5" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
									</svg>
									此为汇总统计，发货请按上方清单，勿按本区重复发货
									<svg class="print-goods-stats__warn" viewBox="0 0 24 24" aria-hidden="true">
										<path d="M12 2L1 21h22L12 2z" fill="#d97706"/>
										<path d="M12 9v6M12 17.5v.5" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
									</svg>
								</span>
							</div>
							<div class="print-goods-stats__list">
								<div
									v-for="g in printGoodsStats.detailRows"
									:key="g.kind + '-' + g.key"
									class="print-goods-stats__row">
									<div class="print-goods-stats__name">{{ g.label }}</div>
									<div class="print-goods-stats__fields">
										<div class="print-goods-stats__field print-goods-stats__field--length">
											<template v-if="g.kind === 'length'">
												<span class="print-goods-stats__label">总长度</span>
												<span class="num">{{ g.lengthText }}</span>
												<span class="print-goods-stats__unit">mm</span>
											</template>
										</div>
										<div class="print-goods-stats__field print-goods-stats__field--qty">
											<span class="print-goods-stats__label">共</span>
											<span class="num">{{ g.qtyText }}</span>
											<span class="print-goods-stats__unit">{{ g.kind === 'length' ? '支' : '个' }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					</div>
				</div>
			</div>
		</common-body>
		<el-dialog
			class="print-shot-dialog"
			:visible.sync="shotVisible"
			:append-to-body="true"
			:fullscreen="isMobile"
			:width="isMobile ? '100%' : '760px'"
			:show-close="true"
			title="报价单截图">
			<div class="print-shot-preview">
				<img v-if="shotUrl" :src="shotUrl" class="print-shot-img" alt="报价单" />
			</div>
			<span slot="footer" class="print-shot-footer">
				<el-button @click="downloadShot">下载</el-button>
				<el-button type="primary" @click="copyShot">复制</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import html2canvas from 'html2canvas'
	import printJS from 'print-js'
	import {
		accMul,
		accDiv,
		accAdd,
		accSub,
		priceChange,
		getT
	} from "../assets/js/public.js"
	import { applyMobileViewport } from '@/utils/isMobile'
	import { cartDisplayName } from '@/utils/cart-display'
	import { sumExtraFeeLines, mergeReadonlyTableRows, isExtraTableRow } from '@/utils/extra-fees'
	import { buildCartGoodsStats } from '@/utils/cart-stats'
	import { downloadOfferExcel } from '@/assets/js/offer-excel.js'
	export default {
		name: 'Print',
		data() {
			let that = this
			return {
				baseUrl: process.env.CDN_BASE || "http://127.0.0.1:19000/baojia-system",
				statusText: [0,'我的报价','我的订单','生产查询','生产查询'],
				title: [0,'报价单','发货单','发货单','加工单'],
				offer_id: 7,
				status: 1,
				resizeable: !1,
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				readonly: !0,
				loadingStatus: !0,
				detail: null,
				img: '',
				aside: ['0','4','5','6','6'],
				payQrcode: '',
				inlineEdit: null,
				inlineEditValue: '',
				/** 折扣让利双击编辑（仅本页预览，不写库） */
				editingConcession: false,
				concessionEditValue: '',
				_concessionCommitting: false,
				isMobile: false,
				printScale: 1,
				sheetHeight: 0,
				sheetOffsetX: 0,
				capturingPrint: false,
				shotVisible: false,
				shotUrl: '',
				shotPngBlob: null,
			}
		},
		created() {
			this.updateIsMobile()
			this.reload();
		},
		mounted() {
			this.updateIsMobile()
			this.syncPrintScale()
			window.addEventListener('resize', this.onPrintResize)
			window.addEventListener('orientationchange', this.onPrintResize)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.onPrintResize)
			window.removeEventListener('orientationchange', this.onPrintResize)
		},
		watch: {
			detail() {
				this.$nextTick(() => {
					this.syncPrintScale()
					setTimeout(this.syncPrintScale, 200)
				})
			},
			printTableRows() {
				this.$nextTick(() => {
					this.syncPrintScale()
				})
			},
		},
		components: {},
		computed: {
			listTitleText() {
				const status = Number(this.status)
				if (status === 4) return '加工清单：'
				if (status === 2 || status === 3) return '发货清单：'
				return '感谢贵司询价，现报价如下：'
			},
			printTableRows() {
				if (!this.detail) return []
				const includeExtras = Number(this.status) === 1
				return mergeReadonlyTableRows(this.detail.goodslist, this.detail.extra_fees, { includeExtras })
			},
			/** 与报价页「统计」一致：按 SKU/规格汇总长度与支数 */
			printGoodsStats() {
				const list = this.detail && Array.isArray(this.detail.goodslist) ? this.detail.goodslist : []
				return buildCartGoodsStats(list)
			},
			sheetViewportStyle() {
				if (!this.sheetHeight) return null
				return { height: Math.ceil(this.sheetHeight * this.printScale) + 'px' }
			},
			sheetScaleStyle() {
				return {
					transform: 'scale(' + this.printScale + ')',
					transformOrigin: 'top left',
					marginTop: this.isMobile ? '8px' : '12px',
					marginLeft: this.sheetOffsetX + 'px',
				}
			},
		},
		methods: {
			cartDisplayName,
			isExtraTableRow,
			updateIsMobile() {
				this.isMobile = applyMobileViewport()
			},
			onPrintResize() {
				this.updateIsMobile()
				this.syncPrintScale()
			},
			layoutPrintTable() {
				const table = this.$refs.printTable
				if (table && typeof table.doLayout === 'function') table.doLayout()
			},
			syncPrintScale() {
				this.$nextTick(() => {
					this.layoutPrintTable()
					const form = this.$refs.offerPrint
					const box = this.$el && this.$el.querySelector('.quotation_box')
					if (!form || !box) return
					const pad = this.isMobile ? 16 : 0
					const avail = box.clientWidth - pad
					if (!(avail > 0)) return
					this.sheetHeight = form.scrollHeight || form.offsetHeight
					const widthScale = avail / 1486
					if (this.isMobile) {
						this.printScale = Math.min(1, widthScale)
					} else {
						this.printScale = Math.min(0.65, widthScale)
					}
					const visualW = 1486 * this.printScale
					this.sheetOffsetX = Math.max(0, Math.round((avail - visualW) / 2 + (this.isMobile ? 8 : 0)))
					this.$nextTick(this.layoutPrintTable)
				})
			},
			printTableRowClassName({ row }) {
				return isExtraTableRow(row) ? 'quotation-row--extra' : ''
			},
			formatMoney(val) {
				if (val === undefined || val === null || val === '') return ''
				let text = String(val).trim()
				if (!text) return ''
				if (text.indexOf('¥') === 0 || text.indexOf('￥') === 0) text = text.slice(1).trim()
				const num = Number(text)
				if (!Number.isFinite(num)) return '¥ ' + text
				return '¥ ' + num.toFixed(2)
			},
			/** 金额列：按单价（singleton）× 数量，不按折扣价 */
			formatAmountBySingleton(row) {
				if (!row) return ''
				const unit = Number(row.singleton)
				const num = Number(row.goods_num)
				if (!Number.isFinite(unit) || !Number.isFinite(num)) return this.formatMoney(row.singleton)
				return this.formatMoney(accMul(unit, num))
			},
			lineAmountBySingleton(row) {
				if (!row) return 0
				const unit = Number(row.singleton)
				const num = Number(row.goods_num)
				if (!Number.isFinite(unit) || !Number.isFinite(num)) return 0
				return Number(accMul(unit, num).toFixed(2))
			},
			formatSizeText(text) {
				if (text === undefined || text === null || text === '' || text === '-') return text
				return String(text).replace(/长/g, '')
			},
			formatFooterMoney(val) {
				if (val === undefined || val === null || val === '') return '0.00'
				const num = Number(val)
				if (!Number.isFinite(num)) return String(val)
				return num.toFixed(2)
			},
			resolveDiscountPrice(row) {
				if (!row) return ''
				if (row.discount_price !== undefined && row.discount_price !== null && row.discount_price !== '') {
					return row.discount_price
				}
				return row.singleton
			},
			isSamePrice(a, b) {
				const na = Number(a)
				const nb = Number(b)
				if (Number.isFinite(na) && Number.isFinite(nb)) {
					return Math.abs(na - nb) < 1e-6
				}
				const emptyA = a === undefined || a === null || a === ''
				const emptyB = b === undefined || b === null || b === ''
				if (emptyA && emptyB) return true
				return String(a) === String(b)
			},
			isDiscountSameAsSingleton(row) {
				if (!row) return true
				return this.isSamePrice(this.resolveDiscountPrice(row), row.singleton)
			},
			isEditingCell(field, index) {
				return this.inlineEdit && this.inlineEdit.field === field && this.inlineEdit.index === index
			},
			startInlineEdit(field, index, value) {
				if (Number(this.status) !== 1) return
				this.inlineEdit = { field, index }
				this.inlineEditValue = this.stripMoneyValue(value)
				this.focusInlineInput()
			},
			stripMoneyValue(value) {
				let text = String(value ?? '').trim()
				if (!text) return ''
				if (text.indexOf('¥') === 0 || text.indexOf('￥') === 0) text = text.slice(1).trim()
				return text
			},
			finishInlineEdit() {
				this.inlineEdit = null
				this.inlineEditValue = ''
			},
			focusInlineInput() {
				this.$nextTick(() => {
					const root = this.$el
					if (!root) return
					const input = root.querySelector('.print-inline-input input')
					if (input) {
						input.focus()
						input.select()
					}
				})
			},
			normalizeMoneyInput(raw) {
				const text = String(raw ?? '').trim().replace(/^[¥￥]\s*/, '')
				if (!text) return { valid: true, value: 0, display: '' }
				const num = Number(text)
				if (!Number.isFinite(num) || num < 0) return { valid: false, value: 0, display: '' }
				return { valid: true, value: num, display: num.toFixed(2) }
			},
			recalcLineAmount(row, unitPrice) {
				const unit = unitPrice != null ? Number(unitPrice) : Number(row.singleton)
				const num = Number(row.goods_num)
				const safeUnit = Number.isFinite(unit) ? unit : 0
				const safeNum = Number.isFinite(num) ? num : 0
				const amount = Number(accMul(safeUnit, safeNum).toFixed(2))
				this.$set(row, 'goods_original_price', amount)
			},
			commitSingletonEdit(index) {
				if (!this.inlineEdit || this.inlineEdit.field !== 'singleton' || this.inlineEdit.index !== index) return
				const row = this.detail.goodslist[index]
				const rawValue = this.inlineEditValue
				this.finishInlineEdit()
				if (!row) return
				const parsed = this.normalizeMoneyInput(rawValue)
				if (!parsed.valid) {
					this.$message.warning('请输入有效的单价')
					return
				}
				this.$set(row, 'singleton', parsed.display)
				this.$set(row, 'discount_price', parsed.display)
				this.recalcLineAmount(row, parsed.value)
				// 改单价后重算小计；保留当前折扣让利（含双击改过的值）
				this.getTotal()
			},
			startConcessionEdit() {
				if (Number(this.status) !== 1 || this.editingConcession || !this.detail) return
				this._concessionCommitting = false
				this.concessionEditValue = this.stripMoneyValue(this.detail.concessionAbs)
				this.editingConcession = true
				this.$nextTick(() => {
					const el = this.$refs.concessionInput
					if (!el) return
					el.focus()
					el.select()
				})
			},
			cancelConcessionEdit() {
				this._concessionCommitting = true
				this.editingConcession = false
				this.concessionEditValue = ''
				this.$nextTick(() => {
					this._concessionCommitting = false
				})
			},
			finishConcessionEdit() {
				if (!this.editingConcession || this._concessionCommitting) return
				this._concessionCommitting = true
				const parsed = this.normalizeMoneyInput(this.concessionEditValue)
				if (!parsed.valid) {
					this.$message.warning('请输入有效的折扣让利金额')
					this.$nextTick(() => {
						const el = this.$refs.concessionInput
						if (el) {
							el.focus()
							el.select()
						}
						this._concessionCommitting = false
					})
					return
				}
				this.editingConcession = false
				this.$set(this.detail, 'concessionAbs', parsed.display || '0.00')
				this.concessionEditValue = ''
				this.getTotal()
				this.$nextTick(() => {
					this._concessionCommitting = false
				})
			},
			formatProcessSize(item) {
				const long = item.goods_long
				if (long === undefined || long === null || String(long).trim() === '') return '/'
				if (Number(item.goods_valuation) === 1) return '/'
				const addSizeRaw = item.godds_add_size
				const addSize = addSizeRaw === undefined || addSizeRaw === null || addSizeRaw === ''
					? 0
					: Number(addSizeRaw)
				const addSizeVal = Number.isFinite(addSize) ? addSize : 0
				return accSub(long, addSizeVal)
			},
			reload() {
				let that = this
				that.offer_id = that.$route.query.id,that.status = that.$route.query.status
				that.getAccount()
				that.getDetail()
			},
			getAccount() {
				let that = this
				that.$fetch('addons/hlm/api.Index/account').then(function(res) {
					if (res.code == 1 && res.data && res.data.account) {
						that.payQrcode = res.data.account
					} else {
						that.payQrcode = ''
					}
				}).catch(function() {
					that.payQrcode = ''
				})
			},
			getDetail() {
				let that = this
				that.$fetch('addons/hlm/api.Order/getOderDetails', {
					id: that.offer_id
				}).then(function(res) {
					console.log(JSON.parse(JSON.stringify(res)))
					if (res.code == 1) {
						let detail = res.data
						detail.createTime = getT(detail.offertime * 1000), detail.sendTime = getT(detail.sendtime * 1000)
						if (detail.validtime&&detail.validtime!="") detail.validTime = getT(detail.validtime * 1000)
						detail.goodslist.forEach((item) => {
							item.godds_addSize = that.formatProcessSize(item)
							if (item.discount_price === undefined || item.discount_price === null || item.discount_price === '') {
								item.discount_price = item.singleton
							}
						})
						detail.printTitle = detail.category_name+that.title[that.status]
						that.detail = detail, that.loadingStatus = !1
						that.getTotal({ initConcession: true })
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			/**
			 * 打印预览金额（不写库；刷新后按订单重算）
			 * 小计=金额列；折扣让利可双击改（绝对值）；合计=小计−让利
			 * initConcession：按成交价与小计差初始化让利；否则保留当前让利（含手动改过）
			 */
			getTotal(options) {
				let that = this
				const opts = options || {}
				if (!that.detail || !that.detail.goodslist) return
				let subtotal = 0
				let dealSum = 0
				that.detail.goodslist.forEach(function(item) {
					subtotal = accAdd(subtotal, that.lineAmountBySingleton(item))
					const unit = Number(that.resolveDiscountPrice(item))
					const num = Number(item.goods_num)
					if (Number.isFinite(unit) && Number.isFinite(num) && num > 0) {
						dealSum = accAdd(dealSum, Number(accMul(unit, num).toFixed(2)))
					}
				})
				const existingAbs = that.detail.concessionAbs
				const hasAbs = existingAbs !== undefined && existingAbs !== null && existingAbs !== ''
				let concessionAbs
				if (opts.initConcession || !hasAbs) {
					concessionAbs = Math.abs(Number(accSub(dealSum, subtotal)) || 0)
				} else {
					concessionAbs = Math.abs(Number(existingAbs) || 0)
				}
				const extraSum = Number(sumExtraFeeLines(that.detail.extra_fees))
				const total = accAdd(accSub(subtotal, concessionAbs), extraSum)
				that.$set(that.detail, 'totalAll', Number(accAdd(subtotal, extraSum)).toFixed(2))
				that.$set(that.detail, 'concessionAbs', Number(concessionAbs).toFixed(2))
				that.$set(that.detail, 'concession', Number(accSub(0, concessionAbs)).toFixed(2))
				that.$set(that.detail, 'total', Number(total).toFixed(2))
				that.$set(that.detail, 'totalText', priceChange(that.detail.total))
			},
			delOffer() {
				let that = this
				that.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$fetch('addons/hlm/api.order/del', {
						id: that.offer_id
					}).then(function(res) {
						console.log(res)
						if (res.code == 1) {
							that.detailStatus = !1, that.$message({
								message: '删除成功',
								type: 'success',
								duration: 1500,
								center: !0,
								onClose() {
									that.$router.goBack()
								}
							})
						}
					}).catch(function(error) {
						console.log(error)
					})
				}).catch(() => {
					that.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			shotFileName() {
				const title = (this.detail && this.detail.printTitle) || '报价单'
				return title.replace(/[\\/:*?"<>|]/g, '_') + '.jpg'
			},
			dataUrlToBlob(dataUrl) {
				const parts = String(dataUrl).split(',')
				const mimeMatch = parts[0] && parts[0].match(/:(.*?);/)
				const mime = (mimeMatch && mimeMatch[1]) || 'image/jpeg'
				const binary = atob(parts[1] || '')
				const len = binary.length
				const bytes = new Uint8Array(len)
				for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i)
				return new Blob([bytes], { type: mime })
			},
			downscaleCanvas(canvas, maxWidth) {
				if (!canvas || !maxWidth || canvas.width <= maxWidth) return canvas
				const ratio = maxWidth / canvas.width
				const out = document.createElement('canvas')
				out.width = maxWidth
				out.height = Math.max(1, Math.round(canvas.height * ratio))
				const ctx = out.getContext('2d')
				ctx.fillStyle = '#ffffff'
				ctx.fillRect(0, 0, out.width, out.height)
				ctx.drawImage(canvas, 0, 0, out.width, out.height)
				return out
			},
			/** 出图稿宽：与 CSS 1486 桌面稿一致，不受平板 rem / 预览缩放影响 */
			normalizePrintClone(form) {
				if (!form) return 1486
				const sheetWidth = 1486
				const padX = 20
				form.removeAttribute('style')
				form.style.cssText = [
					'transform:none',
					'margin:0',
					'width:' + sheetWidth + 'px',
					'min-width:' + sheetWidth + 'px',
					'max-width:' + sheetWidth + 'px',
					'padding:0 ' + padX + 'px 20px',
					'box-sizing:border-box'
				].join(';')
				const tableRoot = form.querySelector('.printTable')
				if (tableRoot) {
					tableRoot.style.width = '100%'
					this.syncClonedTableLayout(tableRoot, sheetWidth - padX * 2)
				}
				return sheetWidth
			},
			dataColsOf(tableRoot, wrapperSel) {
				const cols = tableRoot.querySelectorAll(wrapperSel + ' colgroup col')
				return Array.prototype.filter.call(cols, function(col) {
					return col.getAttribute('name') !== 'gutter'
				})
			},
			readColWidth(col) {
				const attr = parseFloat(col.getAttribute('width'))
				if (Number.isFinite(attr) && attr > 0) return attr
				const styleW = parseFloat(col.style.width)
				return Number.isFinite(styleW) && styleW > 0 ? styleW : 0
			},
			syncClonedTableLayout(tableRoot, targetWidth) {
				if (!tableRoot) return
				tableRoot.querySelectorAll('col[name="gutter"], th.gutter').forEach(function(el) {
					el.setAttribute('width', '0')
					el.style.width = '0px'
					el.style.display = 'none'
					el.style.border = 'none'
				})
				const headerCols = this.dataColsOf(tableRoot, '.el-table__header-wrapper')
				const bodyCols = this.dataColsOf(tableRoot, '.el-table__body-wrapper')
				const sample = headerCols.length ? headerCols : bodyCols
				if (!sample.length) return
				const widths = sample.map(this.readColWidth)
				const sum = widths.reduce(function(acc, n) { return acc + n }, 0)
				const scaled = []
				if (sum > 0 && targetWidth > 0) {
					let used = 0
					widths.forEach(function(w, i) {
						const next = i === widths.length - 1
							? Math.max(1, Math.round(targetWidth - used))
							: Math.max(1, Math.round(w * targetWidth / sum))
						used += next
						scaled.push(next)
					})
				}
				;[headerCols, bodyCols].forEach(function(list) {
					list.forEach(function(col, i) {
						const next = scaled[i]
						if (!next) return
						col.setAttribute('width', String(next))
						col.style.width = next + 'px'
					})
				})
				tableRoot.querySelectorAll('.el-table__header-wrapper, .el-table__body-wrapper, .el-table__header, .el-table__body').forEach(function(el) {
					el.style.width = '100%'
					el.style.minWidth = ''
				})
			},
			afterLayoutFrames(count) {
				const times = Math.max(1, count || 1)
				let chain = Promise.resolve()
				for (let i = 0; i < times; i++) {
					chain = chain.then(() => new Promise(function(resolve) {
						requestAnimationFrame(function() { resolve() })
					}))
				}
				return chain
			},
			waitCloneImages(root) {
				if (!root) return Promise.resolve()
				const imgs = Array.prototype.slice.call(root.querySelectorAll('img'))
				if (!imgs.length) return Promise.resolve()
				return Promise.all(imgs.map(function(img) {
					if (img.complete && img.naturalHeight > 0) {
						return typeof img.decode === 'function' ? img.decode().catch(function() {}) : Promise.resolve()
					}
					return new Promise(function(resolve) {
						const done = function() { resolve() }
						img.addEventListener('load', done, { once: true })
						img.addEventListener('error', done, { once: true })
						if (typeof img.decode === 'function') img.decode().then(done).catch(done)
					})
				}))
			},
			preparePrintCloneOverflow(form) {
				if (!form) return
				form.querySelectorAll('.el-table__body-wrapper, .el-table__header-wrapper, .print-table-scroll').forEach(function(el) {
					el.style.overflow = 'visible'
					el.style.height = 'auto'
					el.style.maxHeight = 'none'
				})
				form.querySelectorAll('.pay_box img').forEach(function(img) {
					img.style.width = '100%'
					img.style.maxWidth = '100%'
					img.style.height = 'auto'
				})
			},
			restorePrintCaptureRem(prevFontSize) {
				const htmlEl = document.documentElement
				if (!htmlEl) return
				htmlEl.classList.remove('is-print-capturing')
				if (this.isMobile) {
					htmlEl.style.fontSize = '192px'
					return
				}
				if (prevFontSize) {
					htmlEl.style.fontSize = prevFontSize
					return
				}
				htmlEl.style.fontSize = ''
				if (window.lib && window.lib.flexible && typeof window.lib.flexible.refreshRem === 'function') {
					window.lib.flexible.refreshRem()
				}
			},
			preparePrintCaptureClone(el) {
				this.normalizePrintClone(el)
				this.preparePrintCloneOverflow(el)
				this.lockPayBoxImageSize(el)
			},
			lockPayBoxImageSize(form) {
				if (!form) return
				const contentW = 1446
				form.querySelectorAll('.pay_box img').forEach(function(img) {
					const box = img.parentElement
					const boxW = (box && box.clientWidth > 0) ? box.clientWidth : contentW
					img.style.width = boxW + 'px'
					img.style.maxWidth = '100%'
					img.style.height = 'auto'
					if (img.naturalWidth > 0 && img.naturalHeight > 0) {
						img.style.height = Math.round(boxW * img.naturalHeight / img.naturalWidth) + 'px'
					}
				})
			},
			measureCloneExtent(el, host) {
				const width = 1486
				if (!el) return { width: width, height: 1 }
				let height = Math.max(el.scrollHeight || 0, el.offsetHeight || 0, 1)
				if (host) height = Math.max(height, host.scrollHeight || 0, host.offsetHeight || 0)
				const root = el.getBoundingClientRect()
				if (root && root.height) height = Math.max(height, Math.ceil(root.height))
				const nodes = el.querySelectorAll('*')
				for (let i = 0; i < nodes.length; i++) {
					const r = nodes[i].getBoundingClientRect()
					if (!r || (r.width === 0 && r.height === 0)) continue
					height = Math.max(height, Math.ceil(r.bottom - root.top))
				}
				return { width: width, height: height }
			},
			ignorePrintCaptureNoise(el) {
				if (!el || !el.classList) return false
				if (el.classList.contains('html2canvas-container')) return true
				if (el.classList.contains('Print') && !el.classList.contains('print-capture-offscreen')) return true
				if (el.classList.contains('el-loading-mask')) return true
				if (el.classList.contains('print-shot-dialog')) return true
				return false
			},
			prepareClonedCaptureDocument(clonedDoc, el, sheetWidth, sheetHeight) {
				if (clonedDoc && clonedDoc.documentElement) {
					clonedDoc.documentElement.style.fontSize = '192px'
					clonedDoc.documentElement.style.overflow = 'visible'
					clonedDoc.documentElement.style.width = sheetWidth + 'px'
					clonedDoc.documentElement.style.minHeight = sheetHeight + 'px'
					clonedDoc.documentElement.style.height = 'auto'
				}
				if (clonedDoc && clonedDoc.body) {
					clonedDoc.body.style.margin = '0'
					clonedDoc.body.style.overflow = 'visible'
					clonedDoc.body.style.width = sheetWidth + 'px'
					clonedDoc.body.style.minHeight = sheetHeight + 'px'
					clonedDoc.body.style.height = 'auto'
				}
				const off = el && el.closest && el.closest('.print-capture-offscreen')
				if (off) {
					off.style.left = '0'
					off.style.top = '0'
					off.style.right = 'auto'
					off.style.position = 'absolute'
					off.style.width = sheetWidth + 'px'
					off.style.minWidth = sheetWidth + 'px'
					off.style.height = 'auto'
					off.style.minHeight = sheetHeight + 'px'
					off.style.transform = 'none'
					off.style.opacity = '1'
				}
				this.preparePrintCaptureClone(el)
			},
			capturePrintCanvas() {
				const source = this.$refs.offerPrint
				if (!source) return Promise.reject(new Error('no-sheet'))
				const sheetWidth = 1486
				const htmlEl = document.documentElement
				const prevFontSize = htmlEl ? htmlEl.style.fontSize : ''
				const host = document.createElement('div')
				const keepStats = Number(this.status) === 4
				host.className = 'Print is-print-capture print-capture-offscreen' + (keepStats ? ' print-capture-keep-stats' : '')
				host.setAttribute('aria-hidden', 'true')
				const clone = source.cloneNode(true)
				if (!keepStats) {
					const stats = clone.querySelector('.print-goods-stats')
					if (stats && stats.parentNode) stats.parentNode.removeChild(stats)
				}
				host.appendChild(clone)
				document.body.appendChild(host)
				const restore = () => {
					this.restorePrintCaptureRem(prevFontSize)
					if (host.parentNode) host.parentNode.removeChild(host)
				}
				return Promise.resolve()
					.then(() => {
						if (htmlEl) {
							htmlEl.classList.add('is-print-capturing')
							htmlEl.style.fontSize = '192px'
						}
						this.preparePrintCaptureClone(clone)
						return this.waitCloneImages(clone)
					})
					.then(() => this.afterLayoutFrames(3))
					.then(() => {
						this.preparePrintCaptureClone(clone)
						return this.afterLayoutFrames(2)
					})
					.then(() => {
						const extent = this.measureCloneExtent(clone, host)
						const sheetHeight = extent.height + 80
						host.style.width = sheetWidth + 'px'
						host.style.minHeight = sheetHeight + 'px'
						return html2canvas(clone, {
							backgroundColor: '#ffffff',
							useCORS: true,
							allowTaint: true,
							width: sheetWidth,
							height: sheetHeight,
							windowWidth: sheetWidth,
							windowHeight: sheetHeight,
							scale: 2,
							x: 0,
							y: 0,
							scrollX: 0,
							scrollY: 0,
							ignoreElements: (el) => this.ignorePrintCaptureNoise(el),
							onclone: (clonedDoc, el) => {
								this.prepareClonedCaptureDocument(clonedDoc, el, sheetWidth, sheetHeight)
								return this.waitCloneImages(el).then(() => this.afterLayoutFrames(2))
							}
						})
					})
					.finally(restore)
			},
			/** 按 A4 内容区比例切片，避免整张长图撑破一页被推到第二页（第一页空白） */
			sliceCanvasPages(canvas) {
				if (!canvas || !canvas.width || !canvas.height) return []
				const pageHeight = Math.max(1, Math.round(canvas.width * 281 / 194))
				if (canvas.height <= pageHeight) {
					return [canvas.toDataURL('image/png')]
				}
				const pages = []
				let y = 0
				while (y < canvas.height) {
					const h = Math.min(pageHeight, canvas.height - y)
					if (h < 12 && pages.length) break
					const page = document.createElement('canvas')
					page.width = canvas.width
					page.height = h
					const ctx = page.getContext('2d')
					ctx.fillStyle = '#ffffff'
					ctx.fillRect(0, 0, page.width, page.height)
					ctx.drawImage(canvas, 0, y, canvas.width, h, 0, 0, canvas.width, h)
					pages.push(page.toDataURL('image/png'))
					y += h
				}
				return pages
			},
			toImg() { // 转图片打印：屏幕外克隆出图，避免当前预览突然恢复原稿
				if (this.capturingPrint) return
				this.capturingPrint = true
				this.capturePrintCanvas().then((canvas) => {
					const pages = this.sliceCanvasPages(canvas)
					this.img = pages[0] || ''
					printJS({
						printable: pages,
						type: 'image',
						documentTitle: this.detail.printTitle,
						imageStyle: 'display:block;width:100%;height:auto;margin:0;padding:0;page-break-inside:avoid;break-inside:avoid;',
						style: '@page{margin:8mm;}html,body{margin:0;padding:0;}body>div>div{page-break-after:always;break-after:page;}body>div>div:last-child{page-break-after:auto;break-after:auto;}'
					})
				}).catch((error) => {
					console.error(error)
					this.$message({ message: '生成打印图失败，请重试', type: 'error', center: true })
				}).finally(() => {
					this.capturingPrint = false
				})
			},
			toShot() {
				if (this.capturingPrint) return
				this.capturingPrint = true
				const loading = this.$loading({
					lock: true,
					text: '正在生成报价单截图…',
					background: 'rgba(255, 255, 255, 0.7)'
				})
				this.capturePrintCanvas().then((canvas) => {
					const shot = this.downscaleCanvas(canvas, 1080)
					this.shotUrl = shot.toDataURL('image/jpeg', 0.88)
					this.shotPngBlob = null
					return this.canvasToPngBlob(shot).then((blob) => {
						this.shotPngBlob = blob
						this.shotVisible = true
					})
				}).catch((error) => {
					console.error(error)
					this.$message({ message: '截图失败，请重试', type: 'error', center: true })
				}).finally(() => {
					this.capturingPrint = false
					loading.close()
				})
			},
			canvasToPngBlob(canvas) {
				if (!canvas) return Promise.reject(new Error('no-canvas'))
				if (typeof canvas.toBlob === 'function') {
					return new Promise(function(resolve, reject) {
						canvas.toBlob(function(blob) {
							if (blob) resolve(blob)
							else reject(new Error('toBlob-empty'))
						}, 'image/png')
					})
				}
				return Promise.resolve(this.dataUrlToBlob(canvas.toDataURL('image/png')))
			},
			downloadShot() {
				if (!this.shotUrl) return
				const link = document.createElement('a')
				link.href = this.shotUrl
				link.download = this.shotFileName()
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
				this.$message({ message: '若未开始下载，请长按图片保存', type: 'info', center: true, duration: 2000 })
			},
			copyShot() {
				if (!this.shotUrl) return
				if (!navigator.clipboard || typeof window.ClipboardItem !== 'function') {
					this.$message({ message: '当前浏览器不支持复制图片，请改用下载', type: 'warning', center: true })
					return
				}
				const pngBlob = this.shotPngBlob
					? Promise.resolve(this.shotPngBlob)
					: this.dataUrlToPngBlob(this.shotUrl)
				const item = new ClipboardItem({ 'image/png': pngBlob })
				navigator.clipboard.write([item]).then(() => {
					this.$message({ message: '已复制到剪贴板', type: 'success', center: true })
				}).catch((error) => {
					console.error(error)
					this.$message({ message: '复制失败，请改用下载', type: 'error', center: true })
				})
			},
			dataUrlToPngBlob(dataUrl) {
				return new Promise((resolve, reject) => {
					const img = new Image()
					img.onload = () => {
						const canvas = document.createElement('canvas')
						canvas.width = img.naturalWidth || img.width
						canvas.height = img.naturalHeight || img.height
						const ctx = canvas.getContext('2d')
						ctx.fillStyle = '#ffffff'
						ctx.fillRect(0, 0, canvas.width, canvas.height)
						ctx.drawImage(img, 0, 0)
						this.canvasToPngBlob(canvas).then(resolve).catch(reject)
					}
					img.onerror = () => reject(new Error('image-load'))
					img.src = dataUrl
				})
			},
			exportExcel() {
				if (!this.detail) {
					this.$message({ message: '报价单尚未加载完成', type: 'warning', center: true })
					return
				}
				try {
					downloadOfferExcel(this.detail)
				} catch (error) {
					console.error(error)
					this.$message({ message: '导出Excel失败，请重试', type: 'error', center: true })
				}
			},
			goBack() {
				this.$router.back()
			}
		}
	};
</script>

<style src='../assets/css/print.css'>
	/* px2rem能正常转换 */
</style>
<style src='../assets/css/print-mobile.css'></style>
